var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "pay-banner card" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm.salaries
        ? _c("div", { staticClass: "card-body p-3" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-3 text-center salary-compare" }, [
                _vm.compareCode
                  ? _c("span", [
                      _vm.betterOff
                        ? _c(
                            "span",
                            {
                              attrs: {
                                title:
                                  "You could increase your average salary in this job!"
                              }
                            },
                            [
                              _c("i", { staticClass: "fas fa-dollar-sign" }),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(
                                "\n              Potential\n              pay rise!\n            "
                              )
                            ]
                          )
                        : _c(
                            "span",
                            {
                              attrs: {
                                title: "Lookout, you could be taking a pay cut!"
                              }
                            },
                            [
                              _c("i", { staticClass: "far fa-thumbs-down" }),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(
                                "\n              Pay cut\n              alert!\n            "
                              )
                            ]
                          )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-3 text-center female loud",
                  attrs: { title: _vm.titleWomen }
                },
                [
                  _c("i", { staticClass: "fas fa-2x fa-female" }),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", { staticClass: "d-inline" }, [
                    _vm._v("$" + _vm._s(_vm.wef))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-3" },
                [
                  _c("pie-chart", {
                    attrs: { chartdata: _vm.chartData, options: _vm.options }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-3 text-center male loud",
                  attrs: { title: _vm.titleMen }
                },
                [
                  _c("i", { staticClass: "fas fa-2x fa-male" }),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", { staticClass: "d-inline" }, [
                    _vm._v("$" + _vm._s(_vm.wem))
                  ])
                ]
              )
            ])
          ])
        : _c("div", { staticClass: "card-body p-3 text-center" }, [
            _vm._v("\n      No salary data for this job.\n    ")
          ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header text-center" }, [
      _c("b", [_vm._v("Salary summary")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }